<div class="o-date-picker__header-nav" (mousedown)="previousMonth($event)">
    <i class="u-icon u-icon-angle-left"></i>
</div>
<div class="o-date-picker__header-label">
    {{i18n.monthNames[month] + " " + year}}
</div>
<div class="o-date-picker__header-nav" (mousedown)="nextMonth($event)">
    <i class="u-icon u-icon-angle-right"></i>
</div>
